import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { redirectToInternalLink } from 'businessLogic/redirector';
import UserSignUp from '../components/pages/user/user-signup/content';
import { displayGlobalMessage } from 'actions/globalMessage';

const UserSignupPage = (props) => {
  const userSignupCreateForm = useSelector((state) => state.usersReducer.userSignupCreateForm) || {};
  const userProfile = useSelector((state) => state.usersReducer.userProfile);
  const dispatch = useDispatch();
  if (userProfile && userProfile.email && userProfile.email != '') {
    dispatch(
      displayGlobalMessage({
        text: APP.LANGUAGE.ServerErrors.InvalidUserSignupRequest,
        visible: true,
        messageType: 'Bad',
      })
    );
    redirectToInternalLink('/login');
  }
  return (
    <div className="new-user-signup">
      <UserSignUp userSignupCreateForm={userSignupCreateForm} dispatch={dispatch} />
    </div>
  );
};
export default UserSignupPage;
